<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';
  import Button from './Button.svelte';
  import { replaceState } from '$app/navigation';

  export let items = {};
  export let title: string | null = null;
  export let queryParam: string;
  export let itemsToShow: number = 8;

  let showAllItems = false;
  let selectedItems = new Set<string>();
  const dispatch = createEventDispatcher();

  onMount(() => {
    initializeSelectedItemsFromUrl();
  });

  export function appendQueryParamsIfNeeded(params: URLSearchParams) {
    selectedItems.forEach((item) => {
      params.append(queryParam, item);
    });
  }

  export function resetSelectedItems() {
    selectedItems = new Set();
    dispatchSelectedItemsChange();
  }

  /**
   * @deprecated Use appendQueryParamsIfNeeded instead.
   */
  export function updateQueryString() {
    const params = new URLSearchParams(window.location.search);

    params.delete(queryParam);
    selectedItems.forEach((item) => {
      params.append(queryParam, item);
    });

    var newUrl = window.location.pathname;
    if (params.size > 0) {
      newUrl += `?${params.toString()}`;
    }
    replaceState(newUrl, '');
  }

  async function initializeSelectedItemsFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const itemsFromUrl = params.getAll(queryParam);
    if (itemsFromUrl.length > 0) {
      itemsFromUrl.forEach((id) => selectedItems.add(id));
    }

    dispatchSelectedItemsChange();
  }

  function dispatchSelectedItemsChange() {
    dispatch('selectedItemsChange', { selectedItems: Array.from(selectedItems) });
  }
</script>

<h3 class="mb-3">{title}</h3>

<slot {showAllItems} {selectedItems} {itemsToShow} filtersChange={dispatchSelectedItemsChange}
></slot>

{#if Object.entries(items).length > itemsToShow}
  <div>
    <Button
      label={showAllItems ? 'Show less' : 'Show more'}
      type="link"
      click={() => (showAllItems = !showAllItems)}
    >
      {showAllItems ? 'Show less' : 'Show more'}
    </Button>
  </div>
{/if}
